import{useRef as r,useEffect as t}from"react";
// 애니메이션 관련 상수
const n=(n,e)=>{
// 값을 0-100 범위로 제한
const c=Math.min(100,Math.max(0,n)),u=r(void 0),a=r(void 0),o=r(-100),i=r(-100);
// 애니메이션 상태 관리를 위한 refs
return t((()=>{if(!e.current)return;const r=c-100,t=n=>{
// 첫 프레임에서 시작 시간과 값을 설정
a.current||(a.current=n,o.current=i.current);
// 경과 시간 계산
const c=n-a.current,m=Math.min(c/500,1),s=(d=m,1-Math.pow(1-d,4));var d;const v=o.current+(r-o.current)*s;i.current=v,
// DOM 업데이트
e.current&&(e.current.style.transform=`translate3d(${v}%, 0, 0)`),
// 애니메이션 계속 진행
m<1?u.current=requestAnimationFrame(t):a.current=void 0};// 0-100을 -100-0으로 변환
/**
     * ease-out-quart 이징 함수
     * cubic-bezier(0.25, 0.46, 0.45, 0.94)와 유사한 효과
     */
// 클린업 함수
// 진행 중인 애니메이션 취소
return u.current&&(cancelAnimationFrame(u.current),a.current=void 0),
// 새 애니메이션 시작
u.current=requestAnimationFrame(t),()=>{u.current&&cancelAnimationFrame(u.current)}}),[c,e]),c};// ms
export{n as useProgressAnimation};
